import { GET_APPLICATION, GET_APPLICATIONS, GET_VARIANT_GROUPS } from '@/store/types/application';

export function getApplication(data) {
  return { type: GET_APPLICATION, data };
}

export function getApplications() {
  return { type: GET_APPLICATIONS };
}

export function getVariantGroups() {
  return { type: GET_VARIANT_GROUPS };
}
